// SidebarPurchaseItem component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/icon_button/icon_button.jsx'
import InlineInput from '../../../common/inline_input/inline_input.jsx'
import WysiwygEditor from '../../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'

class SidebarPurchaseItem extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      isExpand: false
    }
  }

  static get propTypes () {
    return {
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      total: PropTypes.number,
      editable: PropTypes.string,
      canEdit: PropTypes.bool,
      canDragAndDrop: PropTypes.bool,
      onDeletePoItem: PropTypes.func,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onKeyDown: PropTypes.func,
      onClickEdit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      id: '',
      title: '',
      description: '',
      total: '',
      editable: '',
      canEdit: false,
      canDragAndDrop: false,
      onDeletePoItem: null,
      onChange: null,
      onBlur: null,
      onKeyDown: null,
      onClickEdit: null
    }
  }

  render () {
    const {
      id,
      title,
      description,
      total,
      editable,
      canEdit,
      canDragAndDrop
    } = this.props
    const { isExpand } = this.state

    return (
      <div className='sidebar-purchaseorderitem'>
        <div className='itemcontentinfo'>
          <div className='col colselect' />
          <div className='col colactions'>
            <IconButton
              icon='x'
              size='small'
              type='secondary'
              canHover
              className='deleteicon'
              onClick={this._onDeletePoItem.bind(this, id)}
            />
          </div>
          <div className='titleinfo'>
            <div className='title'>
              <InlineInput
                value={title}
                showInput={editable === 'title'}
                canEdit={canEdit}
                inputType='input'
                onChange={this._onChangeInput.bind(this, 'title')}
                onBlur={this._onBlurInput.bind(this, 'title')}
                onKeyDown={this._onKeyDownInput.bind(this, 'title')}
                onClickEdit={this._onClickEditInput.bind(this, 'title')}
              />
            </div>
          </div>
          <div className={`totalinfo${canDragAndDrop ? '' : ' active'}`}>
            <InlineInput
              value={total}
              showInput={editable === 'total'}
              canEdit={canEdit}
              inputType='input'
              onChange={this._onChangeInput.bind(this, 'total')}
              onBlur={this._onBlurInput.bind(this, 'total')}
              onKeyDown={this._onKeyDownInput.bind(this, 'total')}
              onClickEdit={this._onClickEditInput.bind(this, 'total')}
            />
          </div>
          <div className='col colactions'>
            {canDragAndDrop && (
              <IconButton icon='drag' iconSize='26' className='iconloading' />
            )}
          </div>
        </div>
        {isExpand && (
          <div className='subcontentinfo'>
            {canEdit ? (
              <WysiwygEditor
                placeholder='projectBudget.sidebarActivity.labelDescription'
                value={description}
                onChange={this._onChangeInput.bind(this, 'description')}
                onBlur={this._onBlurInput.bind(this, 'description')}
                onKeyDown={this._onKeyDownInput.bind(this, 'description')}
              />
            ) : (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </div>
        )}
      </div>
    )
  }

  /* Event Handlers */

  _onDeletePoItem (id) {
    if (this.props.onDeletePoItem) {
      this.props.onDeletePoItem(id)
    }
  }

  _onChangeInput = (name, value, ev) => {
    const { id, onChange } = this.props

    if (onChange) {
      onChange(id, name, value, ev)
    }
  };

  _onBlurInput = (name, ev) => {
    const { id, onBlur } = this.props

    if (onBlur) {
      onBlur(id, name, ev)
    }
  };

  _onKeyDownInput = (name, ev) => {
    const { id, onKeyDown } = this.props

    if (onKeyDown) {
      onKeyDown(id, name, ev)
    }
  };

  _onClickEditInput = (name, _ev) => {
    const { id, onClickEdit } = this.props

    if (onClickEdit) {
      onClickEdit(id, name)
    }
  };

  _onToggleExpand (isExpand) {
    this.setState({ isExpand })
  }
}

export default SidebarPurchaseItem
